import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import "./format-20.style.scss";
import { Container, Row } from "react-bootstrap";

const Format20 = (props) => {
  const [data, setData] = useState({});
  const [fotoData, setFotoData] = useState(null);

  useEffect(() => {
    if (props?.item) {
      setData(props.item);
    }
  }, [props.item]);

  useEffect(() => {
    if (props?.item?.data) {
      const parsed = props.item
      console.log("parsed",props.item);
      const data = [];
      if (parsed.images_id) {
        data.push({
          image: parsed.images_id,
          link: parsed.text_button_id,
        });
      }
      if (parsed.images_en) {
        data.push({
          image: parsed.images_en,
          link: parsed.text_button_en,
        });
      }
      setFotoData(data);
    }
  }, [props.item?.data]);

  const checkValue = (val) => val && val !== "";
  const toValidUrl = (url) => /^https?:\/\//i.test(url) ? url : `https://${url}`;

  const FotoCard = ({ url, link, iteration }) => {
    console.log(url);
    console.log(link);
    console.log(iteration);
    const imageSrc = url || "/assets/images/video-default.jpg";

    return (
      <div className={`foto-card ${iteration}`}>
        <div
          className="foto-thumb"
          onClick={() =>  window.location.href = toValidUrl(link) }
        >
          <img src={imageSrc} />
        </div>
      </div>
    );
  };


  return (
    <Container bsPrefix="container-xl format-20" key={props.keyUniq}>
      <div className="content">
        {fotoData && (
          <>
            <div className="main-grid">
              {fotoData.map((item, i) => (
                <FotoCard key={i} iteration={i} url={item.image} link={item.link} />
              ))}
            </div>
          </>
        )}
        
        {checkValue(data?.name) && (
          <Row className="title">
            <h1 className="title-text">{data.name}</h1>
          </Row>
        )}

        {checkValue(data?.desc) && (
          <Row className="desc">{parse(data.desc)}</Row>
        )}

        <div className="btn-back-container">
          <button className="btn-back" onClick={() => window.history.back()}>
            <i className="fa fa-chevron-left"></i>
            <span>Kembali</span>
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Format20;
